const ComplianceReport = () => {
    return (
        <>
        </>
    )
}

export default ComplianceReport;